import { Form, Input } from 'antd';
import React, { FC } from 'react';
import { ISearchData } from 'shared/types/rvd.types';
import { SelectOptions } from '../..';
import style from './index.module.scss';

type TProps = {
  onSearch: (data: string, key: keyof ISearchData) => void;
};
const PersonnelNumber: FC<TProps> = ({ onSearch }) => {
  return (
    <Form.Item
      name={SelectOptions.PN_OPTION}
      className={style.searchInput}
      normalize={value => value.replace(/[^0-9]/g, '')}
    >
      <Input.Search
        placeholder="Поиск сотрудника по табельному №"
        allowClear
        onSearch={val => onSearch(val, 'personnelNumber')}
        maxLength={8}
      />
    </Form.Item>
  );
};

export default PersonnelNumber;
